import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcCloseLargeIcon, IcNewChatIcon } from '@gem/icons';
import { IconButton, IconViewSizes, usePopover, PopoverMenu } from '@gem/ui-kit';

import { Space } from 'STORE/Spaces/Space';

import { useSpacePanelActionsButtonPresenter } from './SpacePanelActionsButton.presenter';
import styles from './SpacePanelActionsButton.styles.m.css';

interface ISpacePanelActionsButtonProps {
  space: Space;
}

export const SpacePanelActionsButton: FC<ISpacePanelActionsButtonProps> = observer(({ space }) => {
  const popover = usePopover<HTMLButtonElement>();
  const presenter = useSpacePanelActionsButtonPresenter(space);

  if (!presenter.menuItems.length) {
    return null;
  }

  return (
    <>
      <IconButton
        className={styles.button}
        iconClassName={styles.icon}
        setRef={popover.containerRef}
        Icon={popover.isOpened ? IcCloseLargeIcon : IcNewChatIcon}
        size={IconViewSizes.Large}
        iconSize={IconViewSizes.Medium}
        theme="20"
        onClick={popover.toggle}
      />

      <PopoverMenu
        className={styles.menu}
        isOpened={popover.isOpened}
        menuItems={presenter.menuItems}
        onClose={popover.close}
        reference={popover.containerRef.current}
        placement="top-end"
      />
    </>
  );
});
